import { render, staticRenderFns } from "./resourceProDetail.vue?vue&type=template&id=61cf61fa&scoped=true&"
import script from "./resourceProDetail.vue?vue&type=script&lang=js&"
export * from "./resourceProDetail.vue?vue&type=script&lang=js&"
import style0 from "./resourceProDetail.vue?vue&type=style&index=0&id=61cf61fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf61fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61cf61fa')) {
      api.createRecord('61cf61fa', component.options)
    } else {
      api.reload('61cf61fa', component.options)
    }
    module.hot.accept("./resourceProDetail.vue?vue&type=template&id=61cf61fa&scoped=true&", function () {
      api.rerender('61cf61fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/resourceProDetail.vue"
export default component.exports